module.exports = __webpack_public_path__ + "media/images/logos/comcard-ee16714e4ed1905ce098f5e545927518.png";